<template>
    <ol class="bullets">
        <li
            v-for="(bullet, bulletKey) in bullets"
            :key="bulletKey"
            :class="[{ active: bulletKey === step }]"
        ></li>
    </ol>
</template>

<script>
export default {
    props: ['step', 'steps'],
    computed: {
        bullets() {
            return new Array(parseInt(this.steps, 10));
        },
    },
};
</script>

<style lang="scss">
.bullets {
    list-style-type: none;
    display: block;
    padding: 0;
    margin: 0;
    line-height: 0;
    height: 8px;
    margin-top: 20px;
    margin-bottom: 14px;

    li {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #dbd1c9;
        margin-left: 3px;
        margin-right: 3px;

        &.active {
            background-color: #4e3a30;
        }
    }
}
</style>
